export type TSectionInfo = {
  backgroundColors: string[];
  imgCount: number;
  modifiedInfoList: TModifiedInfo[];
  prefix: string;
  sizes: TImageSize[];
};

type TModifiedInfo = {
  modifiedDate: string;
  modifiedIndexList: number[];
};

type TImageSize = {
  width: number;
  height: number;
};

export const getValue = (
  modifiedInfo: TModifiedInfo | undefined,
  key: keyof TModifiedInfo,
  defaultValue: string
) => {
  if (!modifiedInfo) {
    return defaultValue;
  }
  if (!key) {
    return defaultValue;
  }

  const value = modifiedInfo[key];

  return value || defaultValue;
};

export const getRecentModifiedDate = (
  index: number,
  modifiedInfoList: TModifiedInfo[]
) => {
  if (!modifiedInfoList) {
    return '';
  }

  const recentModifiedDate = modifiedInfoList.find((modifiedInfo) =>
    modifiedInfo.modifiedIndexList.find(
      (modifiedIndex) => index === modifiedIndex
    )
  );

  return getValue(recentModifiedDate, 'modifiedDate', '');
};

export const getRecentModifiedImageUrl = (
  index: number,
  sectionInfo: TSectionInfo
) => {
  const recentModifiedDate = getRecentModifiedDate(
    index,
    sectionInfo.modifiedInfoList
  );

  return recentModifiedDate
    ? `${sectionInfo.prefix}_${index}_${recentModifiedDate}.png`
    : `${sectionInfo.prefix}_${index}.png`;
};
